module.exports = __webpack_public_path__ + "img/ASO_fr10.605ade18.png";